import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaHome, FaBox, FaShoppingCart, FaUsers, FaKey, FaTags } from 'react-icons/fa';

const AdminLayout = ({ children }) => {
  return (
    <Container fluid>
      <Row>
        <Col md={2} className="bg-light min-vh-100 p-0">
          <div className="admin-sidebar">
            <div className="p-3 border-bottom">
              <h5 className="mb-0">Admin Panel</h5>
            </div>
            <Nav className="flex-column">
              <Nav.Link as={NavLink} to="/admin" end className="d-flex align-items-center">
                <FaHome className="me-2" /> Dashboard
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/products" className="d-flex align-items-center">
                <FaBox className="me-2" /> Products
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/categories" className="d-flex align-items-center">
                <FaTags className="me-2" /> Categories
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/orders" className="d-flex align-items-center">
                <FaShoppingCart className="me-2" /> Orders
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/users" className="d-flex align-items-center">
                <FaUsers className="me-2" /> Users
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/keys" className="d-flex align-items-center">
                <FaKey className="me-2" /> License Keys
              </Nav.Link>
            </Nav>
          </div>
        </Col>
        <Col md={10} className="p-0">
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default AdminLayout;
